import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import PageBanner from '@components/Common/PageBanner';
import { architecturalWorks, interiorWorks } from '@data/portfolio';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './ProjectDetail.css';

const ProjectDetail = () => {
    const { slug } = useParams();
    const allProjects = [...architecturalWorks, ...interiorWorks];
    const project = allProjects.find(p => p.title.toLowerCase().replace(/\s+/g, '-') === slug);

    if (!project) {
        return <Navigate to="/404" />;
    }

    return (
        <>
            <Helmet>
                <title>{project.title} - AT Architects</title>
                <meta name="description" content={project.description} />
            </Helmet>

            <PageBanner
                title={project.title}
                subtitle={project.category}
                backgroundImage={project.images[0]}
            />

            <section className="project-detail-section">
                <div className="project-detail-container">
                    <div className="project-gallery">
                        <Swiper
                            modules={[Navigation, Pagination]}
                            navigation
                            pagination={{ clickable: true }}
                            spaceBetween={20}
                            loop={true}
                        >
                            {project.images.map((img, i) => (
                                <SwiperSlide key={i}>
                                    <img src={img} alt={`${project.title} ${i+1}`} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                    <div className="project-info">
                        <h2>{project.title}</h2>
                        <div className="project-meta">
                            <div className="meta-item">
                                <strong>Category:</strong> {project.category}
                            </div>
                        </div>
                        <p className="project-description">{project.description}</p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ProjectDetail;
